import { SourcingCompany } from '@dustin-web/auth-js/dist/types/types'
import React from 'react'

type Props = {
  countryKey: SourcingCompany | string
  className?: string
  tabIndex?: number
  ariaDescribedby?: string
  popoverRole?: string
  ariaLabel?: string
}

const Flag = ({
  countryKey,
  className,
  tabIndex,
  ariaDescribedby,
  popoverRole,
  ariaLabel,
}: Props) => {
  switch (countryKey.toLocaleUpperCase() as string) {
    case 'SE':
    case 'SWE':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="31"
          viewBox="0 0 50 31"
          fill="none">
          <g clipPath="url(#clip0_10623_7766)">
            <rect width="50" height="31" rx="4" fill="#006AA7" />
            <path
              d="M0 12.4H15.625V0H21.875V12.4H50V18.6H21.875V31H15.625V18.6H0V12.4Z"
              fill="#FECC00"
            />
          </g>
          <defs>
            <clipPath id="clip0_10623_7766">
              <rect width="50" height="31" rx="4" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    case 'DK':
    case 'DNK':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="31"
          viewBox="0 0 50 31"
          fill="none">
          <g clipPath="url(#clip0_10623_7779)">
            <rect width="50" height="31" rx="4" fill="#C8102E" />
            <path
              d="M0 13.2857H16.2162V0H21.6216V13.2857H50V17.7143H21.6216V31H16.2162V17.7143H0V13.2857Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_10623_7779">
              <rect width="50" height="31" rx="4" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    case 'NO':
    case 'NOR':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="31"
          viewBox="0 0 50 31"
          fill="none">
          <g clipPath="url(#clip0_10623_7770)">
            <rect width="50" height="31" rx="4" fill="#BA0C2F" />
            <path d="M22.7273 0H13.6364V31H22.7273V0Z" fill="white" />
            <path d="M50 11.625H0V19.375H50V11.625Z" fill="white" />
            <path d="M20.4546 0H15.9091V31H20.4546V0Z" fill="#00205B" />
            <path d="M50 13.5625H0V17.4375H50V13.5625Z" fill="#00205B" />
          </g>
          <defs>
            <clipPath id="clip0_10623_7770">
              <rect width="50" height="31" rx="4" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    case 'AL':
    case 'ALA':
      return (
        <svg
          className={className ?? 'u-radius-2 country-svg'}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 16"
          tabIndex={tabIndex}
          aria-describedby={ariaDescribedby}
          aria-label={ariaLabel}
          role={popoverRole}>
          <rect fill="#0064AE" width="24" height="16" />
          <rect fill="#FFD300" x="6" width="4" height="16" />
          <rect
            fill="#FFD300"
            x="10"
            y="-4"
            width="4"
            height="24"
            transform="translate(4 20) rotate(-90)"
          />
          <rect fill="#DB0F16" x="7" width="2" height="16" />
          <rect
            fill="#DB0F16"
            x="11"
            y="-4"
            width="2"
            height="24"
            transform="translate(4 20) rotate(-90)"
          />
          <path fill="gray" d="M23.9.1V15.9H.1V.1H23.9M24,0H0V16H24V0Z" />
        </svg>
      )
    case 'FI':
    case 'FIN':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="31"
          viewBox="0 0 50 31"
          fill="none">
          <g clipPath="url(#clip0_10623_7783)">
            <rect width="50" height="31" rx="4" fill="white" />
            <path d="M50 11.2727H0V19.7273H50V11.2727Z" fill="#002F6C" />
            <path d="M22.2222 0H13.8889V31H22.2222V0Z" fill="#002F6C" />
          </g>
          <defs>
            <clipPath id="clip0_10623_7783">
              <rect width="50" height="31" rx="4" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    case 'NL':
    case 'NLD':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="31"
          viewBox="0 0 50 31"
          fill="none">
          <g clipPath="url(#clip0_10623_7788)">
            <path d="M50 0H0V31H50V0Z" fill="#21468B" />
            <path d="M50 0H0V20.6667H50V0Z" fill="white" />
            <path d="M50 0H0V10.3333H50V0Z" fill="#AE1C28" />
          </g>
          <defs>
            <clipPath id="clip0_10623_7788">
              <rect width="50" height="31" rx="4" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    case 'BE':
    case 'BEL':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="31"
          viewBox="0 0 50 31"
          fill="none">
          <g clipPath="url(#clip0_26266_35530)">
            <path d="M0 0H50V31H0V0Z" fill="#EF3340" />
            <path d="M0 0H33.3333V31H0V0Z" fill="#FDDA25" />
            <path d="M0 0H16.6667V31H0V0Z" fill="black" />
          </g>
          <defs> 
            <clipPath id="clip0_26266_35530">
              <rect width="50" height="31" rx="4" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    default:
      return null
  }
}

export default Flag
